<template>
<div class="chapter">
<div class="inner_page">
<h1>Table of Contents</h1>
<p><span href="#/c001" title="Link target outside of Sample">Title Page</span></p>
<p><a href="#/c002">Haunted</a></p>
<p><a href="#/c003">Summary</a></p>
<p><a href="#/c004">Chapter 1 | Sadie</a></p>
<p><span href="#/c005" title="Link target outside of Sample">Chapter 2</span></p>
<p><span href="#/c006" title="Link target outside of Sample">Chapter 3</span></p>
<p><span href="#/c007" title="Link target outside of Sample">Chapter 4</span></p>
<p><span href="#/c008" title="Link target outside of Sample">Chapter 5</span></p>
<p><span href="#/c009" title="Link target outside of Sample">Chapter 6</span></p>
<p><span href="#/c010" title="Link target outside of Sample">Chapter 7</span></p>
<p><span href="#/c011" title="Link target outside of Sample">Chapter 8</span></p>
<p><span href="#/c012" title="Link target outside of Sample">Chapter 9</span></p>
<p><span href="#/c013" title="Link target outside of Sample">Chapter 10</span></p>
<p><span href="#/c014" title="Link target outside of Sample">About the Author Kailin Gow</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?2fa8b1b5